import dictionary from './BetSlip.dictionary.json';

export enum StakeType {
  SINGLE = 1,
  EXPRESS = 2,
  SYSTEM = 3,
}

export enum SubmitStakeType {
  SINGLE = 'single',
  EXPRESS = 'express',
  SYSTEM = 'system',
}

export enum AccountType {
  MAIN_ACCOUNT = 'main',
  PLEDGE_STAKE_ACCOUNT = 'pledge',
  FREE_BET_ACCOUNT = 'free-bet',
}

export enum AmountInputModifier {
  DIVIDE = 1,
  MULTIPLY = 2,
}

export const enum AllowingPricePreference {
  NOTHING = 1,
  ONLY_INCREASE = 2,
  EVERYTHING = 3,
}

export enum AmountValidationResult {
  NO_ERRORS = 0,
  EMPTY_VALUE = 1,
  MIN_NOT_REACHED = 2,
  MAX_EXCEEDED = 3,
  NUMBER_OF_STAKES_NOT_SELECTED = 4,
  BIG_STAKE = 5,
  UNKNOWN = 6,
}

// ---

export enum SubmissionState {
  AWAITING = 0,
  PROCESSING = 1,
  ACCEPTED = 2,
  REJECTED = 4,
  FAILED = 5,
}

// ---

export enum BetPresetType {
  STATIC_VALUE = 0,
  BALANCE_PERCENT = 10,
}

// ---

export enum ActionButtonState {
  DISABLED = 0,
  READY = 1,
  UNAUTHORIZED = 2,
  ACCESS_IS_RESTRICTED = 3,
  UNKNOWN = 4,
}

// ---

export enum TypeOfError {
  GENERAL = 0, // 4, 6, 8, 400, 401, 402, 422, 500
  MATCH = 1, // 1, 2, 404, 406
  BET = 2, // 1, 2, 5, 7, 404, 406
}

// ---

export enum ConflictCase {
  SINGLE = 'incompatible_single',
  EXPRESS = 'incompatible_express',
  SYSTEM = 'incompatible_system',
}

export enum RankValue {
  DEFAULT = 2,
  MAX = 10,
}

/**
 * Hom much time (in milliseconds) we let user to see the results.
 */
export const DISPLAY_RESULTS_TIMEOUT = 2000;

export const MAX_POSSIBLE_NUMBER_OF_BETS = 30;

// статусы приходят с бэкенда описание тут - https://confluence.tennisi.it/pages/viewpage.action?pageId=556204033
export enum FreebetPossibleStatus {
  POSSIBLE = 10,
  ASIAN_FREEBET_IS_FORBIDDEN = 20,
  MATCH_FREEBET_IS_FORBIDDEN = 30,
  SYSTEM_STAKE_IS_FORBIDDEN = 40,
}

export const DISABLED_TITLE_STATUSES =  {
  onlyCurrency: dictionary.onlyCurrency,
  noFullName: dictionary.noFullName,
  noAuth: dictionary.noAuth,
  noChainAvailable: dictionary.noChainAvailable,
  noChainAvailableForSingleGroup: dictionary.noChainAvailableForSingleGroup,
  noFreebetAvailableForSingleGroup: dictionary.noFreebetAvailableForSingleGroup,
  noExpressChainAvailable: dictionary.noExpressChainAvailable,
  noExpressFreebetAvailable: dictionary.noExpressFreebetAvailable,
  noSystemChainAvailable: dictionary.noSystemChainAvailable,
  matchFreebetIsSelected: dictionary.matchFreebetIsSelected,
};

export const REASON_BY_POSSIBLE_STATUS = {
  [FreebetPossibleStatus.POSSIBLE]: dictionary.possible,
  [FreebetPossibleStatus.ASIAN_FREEBET_IS_FORBIDDEN]: dictionary.asianFreebetIsForbidden,
  [FreebetPossibleStatus.MATCH_FREEBET_IS_FORBIDDEN]: dictionary.matchFreebetIsForbidden,
  [FreebetPossibleStatus.SYSTEM_STAKE_IS_FORBIDDEN]: dictionary.systemStakeIsForbidden,
};

// --- stake submission errors
// https://confluence.tennisi.it/pages/viewpage.action?pageId=559284242

export const enum StakeErrorCode {
  LIMIT_IS_EXCEEDED = 4,
  EXPRESS_BANNED = 6,
  BET_PRICE_CHANGED = 8,
  ALREADY_PENDING = 10,
  INVALID_REQUEST = 400,
  AUTHORIZATION_REQUIRED = 401,
  NOT_ENOUGH_MONEY = 402,
  INCOMPATIBLE_BET = 406,
  BID_DECLINED = 422,
  INTERNAL_SYSTEM_ERROR = 500,
}

export const STAKE_ERROR_DICTIONARY = {
  [StakeErrorCode.LIMIT_IS_EXCEEDED]:      dictionary.limitIsExceeded,
  [StakeErrorCode.EXPRESS_BANNED]:         dictionary.expressBanned,
  [StakeErrorCode.BET_PRICE_CHANGED]:      dictionary.stakePriceChanged,
  [StakeErrorCode.ALREADY_PENDING]:        dictionary.alreadyPending,
  [StakeErrorCode.INVALID_REQUEST]:        dictionary.invalidRequest,
  [StakeErrorCode.AUTHORIZATION_REQUIRED]: dictionary.authorizationRequired,
  [StakeErrorCode.NOT_ENOUGH_MONEY]:       dictionary.notEnoughMoney,
  [StakeErrorCode.INCOMPATIBLE_BET]:       dictionary.incompatibleBet,
  [StakeErrorCode.BID_DECLINED]:           dictionary.bidDeclined,
  [StakeErrorCode.INTERNAL_SYSTEM_ERROR]:  dictionary.internalSystemError,
};

export const enum OperatorRefusedCode {
  MATCH_SITUATION_CHANGED = 1,
  BAD_PRICE = 2,
  LIMIT_IS_EXCEEDED_FOR_THIS_BET = 3,
  LIMIT_IS_EXCEEDED_FOR_THIS_MATCH = 4,
  READY_TO_ACCEPT_ONLY_AMOUNT = 5,
}

export const OPERATOR_REFUSED_DICTIONARY = {
  [OperatorRefusedCode.MATCH_SITUATION_CHANGED]: dictionary.bidDeclined,
  [OperatorRefusedCode.BAD_PRICE]: dictionary.bidDeclined,
  [OperatorRefusedCode.LIMIT_IS_EXCEEDED_FOR_THIS_BET]: dictionary.limitIsExceededForThisBet,
  [OperatorRefusedCode.LIMIT_IS_EXCEEDED_FOR_THIS_MATCH]: dictionary.limitIsExceededForThisMatch,
  [OperatorRefusedCode.READY_TO_ACCEPT_ONLY_AMOUNT]: dictionary.readyToAcceptOnlyAmount,
};

// ---

export const enum MatchErrorCode {
  PRICE_CHANGED = 1,
  RECEPTION_CLOSED = 2,
  NOT_FOUND = 404,
  CANNOT_PARTICIPATE_IN_THE_BET = 406,
}

export const MATCH_ERROR_DICTIONARY = {
  [MatchErrorCode.PRICE_CHANGED]:                 dictionary.matchPriceChanged,
  [MatchErrorCode.RECEPTION_CLOSED]:              dictionary.matchReceptionClosed,
  [MatchErrorCode.NOT_FOUND]:                     dictionary.matchNotFound,
  [MatchErrorCode.CANNOT_PARTICIPATE_IN_THE_BET]: dictionary.matchCannotParticipateInTheBet,
};

// ---

export const enum BetErrorCode {
  PRICE_CHANGED = 1,
  RECEPTION_CLOSED = 2,
  SINGLE_BANNED = 5,
  ONE_CLICK_BET_NOT_ALLOWED = 7,
  NOT_FOUND = 404,
  CANNOT_PARTICIPATE_IN_THE_BET = 406,
}

export const BET_ERROR_DICTIONARY = {
  [BetErrorCode.PRICE_CHANGED]:                 dictionary.betPriceChanged,
  [BetErrorCode.RECEPTION_CLOSED]:              dictionary.betReceptionClosed,
  [BetErrorCode.SINGLE_BANNED]:                 dictionary.singleBanned,
  [BetErrorCode.ONE_CLICK_BET_NOT_ALLOWED]:     dictionary.oneClickBetNotAllowed,
  [BetErrorCode.NOT_FOUND]:                     dictionary.betNotFound,
  [BetErrorCode.CANNOT_PARTICIPATE_IN_THE_BET]: dictionary.cannotParticipateInTheBet,
};
